import React from 'react';
import UserNameComponent from '../../../Elements/UserNameComponent';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import InvoiceAutomationJobId from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationJobId.tsx';
import InvoiceAutomationInvoiceId from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationInvoiceId.tsx';
import InvoiceAutomationProjectId from '../../../Contents/ThirdParty/Project/InvoiceAutomation/InvoiceAutomationProjectId.tsx';

// A job taken off one of the automatic invoicing drafts, out of scope for the automation from then on.
export default class InvoiceAutomationExcludedJobItem {
  constructor(item) {
    if (item === undefined) {
      this.InvoiceAutomationExcludedJobId = '';
      this.TpJobId = '';
      this.ThirdPartyJobId = '';
      this.ProjectId = null;
      this.ProjectName = null;
      this.TpClientInvoiceId = '';
      this.RemovedByUserId = '';
      this.RemovedOnUtc = '';
      return;
    }

    this.InvoiceAutomationExcludedJobId = item.invoiceAutomationExcludedJobId;
    this.TpJobId = item.tpJobId;
    this.ThirdPartyJobId = item.thirdPartyJobId ?? '';
    // The job's project as it is now.
    this.ProjectId = item.projectId ?? null;
    this.ProjectName = item.projectName ?? null;
    this.TpClientInvoiceId = item.tpClientInvoiceId;
    this.RemovedByUserId = item.removedByUserId;
    this.RemovedOnUtc = item.removedOnUtc;
  }

  static NameOfTheIdField() {
    return 'InvoiceAutomationExcludedJobId';
  }

  static nameOfTheItemDetailList() {
    return 'Job Taken Off';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateOnlyFields = [];

  static DateFields = [];

  static BoolFields = [];

  // No person is recorded when a run found the job gone from its draft: whoever removed it did so without Bravo
  // knowing, so the run only noticed it.
  static getTakenOffBy(item) {
    if (item.RemovedByUserId === null || item.RemovedByUserId === undefined) {
      return 'Noticed by a run';
    }
    return <UserNameComponent userId={item.RemovedByUserId} />;
  }

  static getTakenOffOn(item) {
    return dateTimeHelper.utcToLocalYYYYsMMsDDsHHsMM(item.RemovedOnUtc);
  }

  static getJob(item) {
    return (
      <InvoiceAutomationJobId
        tpJobId={item.TpJobId}
        thirdPartyJobId={item.ThirdPartyJobId}
      />
    );
  }

  static getTakenOffInvoice(item) {
    return <InvoiceAutomationInvoiceId tpClientInvoiceId={item.TpClientInvoiceId} />;
  }

  static getProject(item) {
    return (
      <InvoiceAutomationProjectId
        projectId={item.ProjectId}
        projectName={item.ProjectName}
      />
    );
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Job', orderById: '', data: InvoiceAutomationExcludedJobItem.getJob },
      { label: 'Project', orderById: '', data: InvoiceAutomationExcludedJobItem.getProject },
      { label: 'Taken Off Invoice', orderById: '', data: InvoiceAutomationExcludedJobItem.getTakenOffInvoice },
      { label: 'Taken Off By', orderById: '', data: InvoiceAutomationExcludedJobItem.getTakenOffBy },
      { label: 'Taken Off On', orderById: '', data: InvoiceAutomationExcludedJobItem.getTakenOffOn },
    ];
  }
}
